<div class="page-header">
	<button
		mat-flat-button
		color="primary"
		routerLink="cadastro"
		class="novo-cliente-btn"
	>
		<mat-icon>add</mat-icon>
		<span class="no-mob">Novo Cliente</span>
	</button>
</div>

<div class="filters-container">
	<div class="search-form" [formGroup]="searchForm">
		<mat-form-field
			class="search-field"
			title="Busca de organizações"
			appearance="outline"
		>
			<mat-label>Pesquisar empresas</mat-label>
			<input
				id="sms-sro"
				type="text"
				matInput
				placeholder="Digite o nome, CNPJ ou razão social"
				formControlName="term"
				(keyup)="onSearchKeyUp($event)"
				(input)="onSearch()"
			/>
			<button
				*ngIf="!searchButton"
				matSuffix
				mat-icon-button
				color="primary"
				aria-label="Clear search"
				(click)="onClearSearch()"
			>
				<mat-icon>close</mat-icon>
			</button>
			<button
				*ngIf="searchButton"
				matSuffix
				mat-icon-button
				color="primary"
				aria-label="Search organizations"
				[disabled]="isSearchButtonDisabled"
				(click)="onSearchClick()"
			>
				<mat-icon>search</mat-icon>
			</button>
		</mat-form-field>
		<div class="d-f line">
			<mat-form-field
				class="mr-xxxs col-1"
				title="Produto"
				appearance="outline"
			>
				<mat-label>Produto</mat-label>
				<mat-select formControlName="productFilter">
					<mat-option
						*ngFor="
							let option of productFilterOptions;
							trackBy: trackByProductOption
						"
						[value]="option.value"
					>
						{{ option.viewValue }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field
				class="mr-xxxs col-1"
				title="Corretora"
				appearance="outline"
			>
				<mat-label>Corretora</mat-label>
				<mat-select formControlName="brokerFilter" multiple>
					<mat-option value="none">Sem Corretora</mat-option>
					<mat-option
						*ngFor="let broker of partnerBrokers; trackBy: trackByBroker"
						[value]="broker.id"
					>
						{{ broker.name_secondary }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>

<div class="active-filters-section" *ngIf="getActiveFilters().length > 0">
	<div class="active-filters-header">
		<span class="active-filters-title">Filtros ativos:</span>
		<button
			class="clear-all-button"
			(click)="clearAllFilters()"
			type="button"
			mat-button
		>
			<mat-icon>clear</mat-icon>
			Limpar todos
		</button>
	</div>
	<div class="active-filters-container">
		<app-active-filter-badge
			*ngFor="let filter of getActiveFilters(); trackBy: trackByFilter"
			[label]="filter.label"
			[value]="filter"
			(remove)="removeFilter($event)"
		></app-active-filter-badge>
	</div>
</div>

<div class="loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>

<div
	*ngIf="
		brokerStats.organizations > 0 &&
		!isLoading &&
		searchForm.get('brokerFilter')?.value?.length > 0
	"
	class="broker-stats"
>
	<mat-icon class="stats-icon">info</mat-icon>
	<span>
		Exibindo
		<strong>{{ brokerStats.organizations }}</strong>
		organizações e
		<strong>{{ brokerStats.lives | number }}</strong>
		vidas para as corretoras selecionadas.
	</span>
</div>

<div class="organizations-content">
	<ng-container *ngIf="filteredOrganizations.length && !isLoading">
		<div
			class="organization-card"
			*ngFor="
				let organization of filteredOrganizations;
				trackBy: trackByOrganization
			"
		>
			<div class="organization-header">
				<div class="organization-title">
					<div class="organization-icon">
						<mat-icon svgIcon="sanus-business"></mat-icon>
					</div>
					<div class="organization-name-container">
						<h3 class="organization-name to-ellipsis">
							{{
								organization.name_economic_group || organization.name_secondary
							}}
						</h3>
						<span class="organization-subtitle">Grupo Empresarial</span>
					</div>
				</div>
				<div
					*ngIf="organization.hasDigitalHospital"
					class="hospital-digital-badge"
				>
					<mat-icon class="badge-icon">local_hospital</mat-icon>
					<span class="badge-text">Hospital Digital</span>
				</div>
				<div class="organization-summary">
					<div class="summary-item hide-on-mobile">
						<span class="summary-label">Total de usuários</span>
						<span class="summary-value">
							{{ organization._count.totalUsers }}
						</span>
					</div>
					<div class="summary-item">
						<span class="summary-label">
							Total
							<span class="hide-on-mobile">de beneficiários</span>
						</span>
						<span class="summary-value">
							{{ organization._count.totalBeneficiaries }}
						</span>
					</div>
				</div>
			</div>

			<div class="organization-companies">
				<app-organization-info
					[cnpj]="organization.cnpj | mask: '00.000.000/0000-00'"
					[id]="organization.id"
					[name]="organization.name_secondary"
					[isFavorite]="organization.isFavorite"
					[isMatriz]="organization.is_matriz"
					[state]="organization.address.state | statelabel"
					[totalBeneficiaries]="organization._count.beneficiaries || 0"
					[totalUsers]="organization._count.users || 0"
					[partnerBroker]="organization.partnerBroker ?? null"
					[products]="organization.products || []"
					(editGroup)="onEditGroup(organization.id, $event)"
					(toggleFavoriteClicked)="onToggleFavorite(organization.id)"
					class="main-organization"
				></app-organization-info>

				<div
					class="subsidiaries-container"
					*ngIf="
						organization.subsidiaries && organization.subsidiaries.length > 0
					"
				>
					<app-organization-info
						*ngFor="
							let subsidiary of organization.subsidiaries;
							trackBy: trackBySubsidiary
						"
						[cnpj]="subsidiary.cnpj | mask: '00.000.000/0000-00'"
						[id]="subsidiary.id"
						[name]="subsidiary.name_secondary"
						[isFavorite]="subsidiary.isFavorite"
						[isMatriz]="subsidiary.is_matriz"
						[state]="subsidiary.address.state | statelabel"
						[totalBeneficiaries]="subsidiary._count.beneficiaries"
						[totalUsers]="subsidiary._count.users"
						[partnerBroker]="
							subsidiary.partnerBroker ?? organization.partnerBroker ?? null
						"
						[products]="organization.products || []"
						(toggleFavoriteClicked)="onToggleFavorite(subsidiary.id)"
						(editGroup)="onEditGroup(subsidiary.id, $event)"
						class="subsidiary-organization"
					></app-organization-info>
				</div>
			</div>
		</div>

		<mat-paginator
			*ngIf="!isLoading && filteredOrganizations.length > 0"
			showFirstLastButtons
			[pageSizeOptions]="[10, 20, 50, 100]"
			[length]="count"
			[pageSize]="limit"
			[pageIndex]="currentPage - 1"
			(page)="onPageChange($event)"
			aria-label="Selecione a página de organizações"
		></mat-paginator>
		<div class="pb-huge">&nbsp;</div>
	</ng-container>

	<div class="empty-state" *ngIf="!filteredOrganizations.length && !isLoading">
		<mat-icon class="empty-icon">business_center</mat-icon>
		<h3>Nenhuma organização encontrada</h3>
		<p>Tente ajustar os filtros ou termo de pesquisa</p>
	</div>
</div>
